import React, { useState } from 'react';

export interface IInfoPillProps {
	message: string;
}

export const InfoPill: React.FC<IInfoPillProps> = (props) => {
	const [isCollapsed, setIsCollapsed] = useState(true);
	const toggleIsCollapsed = () => setIsCollapsed(!isCollapsed);

	return <>
		<div className="info-pill"><a onClick={toggleIsCollapsed}>What is this?</a></div>
		{!isCollapsed ? <p className="info-pill__message">{props.message}</p> : ''}
	</>;
};
